import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _activity" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "icon_wrap" }
const _hoisted_7 = ["alt"]
const _hoisted_8 = {
  href: "javascript:void(0)",
  style: {"cursor":"default"}
}
const _hoisted_9 = { class: "sub_page_con_view con_view" }
const _hoisted_10 = { class: "tit_wrap flex_wrap" }
const _hoisted_11 = { class: "con_tit" }
const _hoisted_12 = { class: "con_tit_info event" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "tit_info_item" }
const _hoisted_15 = { class: "writer_info" }
const _hoisted_16 = { class: "con_info_wrap" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "info_desc" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "info_desc" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 0,
  class: "file_list_wrap _column"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "file_name" }
const _hoisted_26 = {
  key: 1,
  class: "apply_wrap btn_wrap _default _center"
}
const _hoisted_27 = {
  key: 0,
  class: "apply_wrap btn_wrap _default right_btn"
}
const _hoisted_28 = { class: "list_wrap" }
const _hoisted_29 = { class: "list_tit elips_1" }
const _hoisted_30 = {
  key: 0,
  class: "list_date"
}
const _hoisted_31 = {
  key: 1,
  class: "list_date"
}
const _hoisted_32 = { class: "list_tit elips_1" }
const _hoisted_33 = {
  key: 0,
  class: "list_date"
}
const _hoisted_34 = {
  key: 1,
  class: "list_date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalApplicantCheckForCampaign = _resolveComponent("ModalApplicantCheckForCampaign")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_EventModal = _resolveComponent("EventModal")!
  const _component_PaperModal = _resolveComponent("PaperModal")!
  const _component_IframeModal = _resolveComponent("IframeModal")!
  const _component_ModalTermsForBoard = _resolveComponent("ModalTermsForBoard")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"deco_wrap\" data-v-cb1c1114><i class=\"deco_01\" data-v-cb1c1114><img src=\"img/activity_left.png\" data-v-cb1c1114></i><i class=\"deco_02 _small blink4\" data-v-cb1c1114><img src=\"img/b_icon_01.png\" data-v-cb1c1114></i><i class=\"deco_03 _small blink_zoom1\" data-v-cb1c1114><img src=\"img/b_icon_02.png\" data-v-cb1c1114></i><i class=\"deco_04 _xxsmall blink_zoom4\" data-v-cb1c1114><img src=\"img/b_icon_05.png\" data-v-cb1c1114></i><i class=\"deco_05 none_768 spin2 _medium\" data-v-cb1c1114><img src=\"img/b_icon_03.png\" data-v-cb1c1114></i><i class=\"deco_06 none_768 spin_blink3 _small\" data-v-cb1c1114><img src=\"img/b_icon_01.png\" data-v-cb1c1114></i><i class=\"deco_07 none_768 blink_zoom4 _small\" data-v-cb1c1114><img src=\"img/b_icon_02.png\" data-v-cb1c1114></i><i class=\"deco_character\" data-v-cb1c1114><img src=\"img/activity_icon.png\" data-v-cb1c1114></i></div><div class=\"banner_wrap wrap_1120\" data-v-cb1c1114><h2 data-v-cb1c1114>시민참여 활동</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민활동", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "캠페인·이벤트", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([$setup.state.tab === 3 ? 'active' : ''])
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "참여하고 싶은 반성매매 활동 제안", -1)
            ]))], 2),
            ($setup.user.isLogin())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab(4))),
                  class: _normalizeClass([[$setup.state.tab === 4 ? 'active' : ''], "w_1024_custom_width"])
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("a", { href: "javascript:void(0)" }, "액션 시민 활동", -1)
                ]))], 2))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "반성매매 시민활동"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/board', query: { type: 2 } } }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode("캠페인·이벤트", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: $setup.state.data.title
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("a", _hoisted_8, _toDisplayString($setup.state.data.title), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString($setup.state.data.title), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_13, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.createDate), ".", true)), 1),
                _createElementVNode("span", _hoisted_14, [
                  _cache[22] || (_cache[22] = _createElementVNode("img", {
                    src: "img/view.png",
                    alt: ""
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString($setup.state.data.viewCnt), 1)
                ])
              ]),
              _createElementVNode("span", _hoisted_15, [
                _cache[23] || (_cache[23] = _createElementVNode("span", null, "작성자", -1)),
                _createTextVNode(" " + _toDisplayString($setup.state.data.writer), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            ($setup.state.data.applyDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "info_tit" }, [
                    _createElementVNode("img", {
                      src: "img/info_icon_02.png",
                      alt: "신청 마감"
                    }),
                    _createTextVNode(" 신청 마감 ")
                  ], -1)),
                  _createElementVNode("span", _hoisted_18, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.applyDate), ".", false)), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.state.data.cntApply > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "info_tit" }, [
                    _createElementVNode("img", {
                      src: "img/info_icon_03.png",
                      alt: "모집인원"
                    }),
                    _createTextVNode(" 모집인원 ")
                  ], -1)),
                  _createElementVNode("span", _hoisted_20, _toDisplayString($setup.state.data.cntApply ? $setup.CommonUtils.numberFormat($setup.state.data.cntApply) : "") + "명", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: "content",
              innerHTML: $setup.CommonUtils.decodeContent($setup.state.data.content)
            }, null, 8, _hoisted_22),
            ($setup.state.data.fileList != null && $setup.state.data.fileList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.idx
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => ($setup.downloadFile(item.file, item.imgRealName))
                      }, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(item.imgRealName), 1),
                        _cache[26] || (_cache[26] = _createElementVNode("img", {
                          src: "img/download.png",
                          alt: ""
                        }, null, -1))
                      ], 8, _hoisted_24)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!$setup.state.hasAuth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  ($setup.state.data.state === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        ($setup.state.data.idx === $setup.state.eventIdx)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "common_btn w_130",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.participate && $setup.participate(...args)))
                            }, "참여하기"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "common_btn w_130",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.apply && $setup.apply(...args)))
                            }, "신청하기"))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "common_btn _gray w_130",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.router.push('/board?type=2')))
                  }, "목록")
                ]))
              : _createCommentVNode("", true)
          ]),
          ($setup.state.hasAuth)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("button", {
                  class: "common_btn _gray",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args)))
                }, "삭제"),
                _createElementVNode("button", {
                  class: "common_btn",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.router.push({ name: 'EventModify', params: { id: $setup.state.idx } })))
                }, "수정"),
                (!$setup.state.isMobile && new Date($setup.state.data.recruitStartDate) < new Date())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "common_btn",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.showModalForApply && $setup.showModalForApply(...args)))
                    }, " 신청인원 "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "common_btn",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.router.push('/board?type=2')))
                }, "목록")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          ($setup.state.data.next)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'EventView', params: { id: $setup.state.data.next.idx } },
                class: "next_list"
              }, {
                default: _withCtx(() => [
                  _cache[27] || (_cache[27] = _createElementVNode("span", null, "다음글", -1)),
                  _createElementVNode("div", _hoisted_29, _toDisplayString($setup.state.data.next.title), 1),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.next.createDate), ".", true)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date($setup.state.data.next.createDate), ".", true)), 1))
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          ($setup.state.data.prev)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'EventView', params: { id: $setup.state.data.prev.idx } },
                class: "prev_list"
              }, {
                default: _withCtx(() => [
                  _cache[28] || (_cache[28] = _createElementVNode("span", null, "이전글", -1)),
                  _createElementVNode("div", _hoisted_32, _toDisplayString($setup.state.data.prev.title), 1),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.prev.createDate), ".", true)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date($setup.state.data.prev.createDate), ".", true)), 1))
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.state.isShowModalForApply)
      ? (_openBlock(), _createBlock(_component_ModalApplicantCheckForCampaign, {
          key: 0,
          idx: $setup.state.idx,
          data: $setup.state.data,
          onClose: _cache[12] || (_cache[12] = ($event: any) => ($setup.state.isShowModalForApply = false)),
          onSave: $setup.saveMemo
        }, null, 8, ["idx", "data", "onSave"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          isPossible: true,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModalEvent)
      ? (_openBlock(), _createBlock(_component_EventModal, {
          key: 2,
          title: "<액션시민> 반성매매 온라인 캠페인",
          onClose: $setup.closeEventModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModalApply)
      ? (_openBlock(), _createBlock(_component_PaperModal, {
          key: 3,
          list: $setup.state.listForm,
          onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.isShowModalApply = false)),
          onSave: $setup.answerSave
        }, null, 8, ["list", "onSave"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowIframe)
      ? (_openBlock(), _createBlock(_component_IframeModal, {
          key: 4,
          url: $setup.state.modalContent,
          onClose: $setup.closeIframe
        }, null, 8, ["url", "onClose"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowTerm && $setup.state.data.term)
      ? (_openBlock(), _createBlock(_component_ModalTermsForBoard, {
          key: 5,
          content: $setup.CommonUtils.decodeContent($setup.state.data.term),
          onClose: $setup.closeTerm
        }, null, 8, ["content", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}